"use strict";
var _this = this;
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import velocity from "velocity-animate";
//import 'velocity-animate/velocity.ui'
import isElement from "lodash/isElement";
import defer from "lodash/defer";
export default {
    /**
   * [animate description]
   * @param  {object} attrs   consists of css attributes to be animated
   * @param  {object} options consists of attributes: duration, easing, complete,...
   *                          List of all available attributes: http://julian.com/research/velocity/#arguments
   */ animate: function animate(attrs, options) {
        var elem = !!options.ref && isElement(options.ref) ? options.ref : ReactDOM.findDOMNode(this);
        //Force HA
        attrs.translateZ = !attrs.translateZ ? 0 : attrs.translateZ;
        defer(function() {
            velocity($(elem)[0], attrs, options);
        });
    },
    stopAnimation: function(ref, imidient) {
        var elem = !!ref && isElement(ref) ? ref : ReactDOM.findDOMNode(_this);
        velocity(elem, "stop", imidient);
        if (!imidient) {
            velocity("reverse");
        }
    }
};
